/* PickleAimPro — Theme JS
 * Handles: header scroll, product gallery, FAQ accordion, sticky cart bar, video overlay, scroll reveal
 */

document.addEventListener('DOMContentLoaded', function () {

  // ===== HEADER SCROLL =====
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== MOBILE MENU =====
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
    // Close on link click
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => mobileNav.classList.remove('open'));
    });
  }

  // ===== PRODUCT GALLERY =====
  const mainImage = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img').src;
        const alt = thumb.querySelector('img').alt;
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = src;
          mainImage.alt = alt;
          mainImage.style.opacity = '1';
        }, 150);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  // ===== FAQ ACCORDION =====
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-item__question');
    if (question) {
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        // Close all
        faqItems.forEach(i => i.classList.remove('open'));
        // Toggle clicked
        if (!isOpen) item.classList.add('open');
      });
    }
  });

  // ===== STICKY CART BAR =====
  const stickyBar = document.getElementById('sticky-cart-bar');
  if (stickyBar) {
    stickyBar.classList.remove('hidden');
    const onScrollSticky = () => {
      stickyBar.classList.toggle('visible', window.scrollY > 500);
    };
    window.addEventListener('scroll', onScrollSticky, { passive: true });
  }

  // ===== VIDEO AUTOPLAY ON SCROLL + CLICK-TO-PLAY OVERLAY =====
  const videoWraps = document.querySelectorAll('.video-section__video-wrap');
  videoWraps.forEach(wrap => {
    const overlay = wrap.querySelector('.video-section__play-overlay');
    const video = wrap.querySelector('video');
    if (!video) return;

    // Click overlay to play manually
    if (overlay) {
      overlay.addEventListener('click', () => {
        video.play();
        overlay.style.display = 'none';
      });
      // Show overlay again if video pauses (e.g. user taps pause)
      video.addEventListener('pause', () => {
        // Only show overlay if video wasn't auto-paused by scroll-out
        if (!video._scrollPaused) {
          overlay.style.display = 'flex';
        }
      });
    }

    // Intersection Observer: autoplay when 50% visible, pause when out
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Autoplay muted (required by browsers); unmute if user already interacted
            video.muted = true;
            video._scrollPaused = false;
            video.play().catch(() => {}); // silently ignore if browser blocks
            if (overlay) overlay.style.display = 'none';
          } else {
            video._scrollPaused = true;
            video.pause();
          }
        });
      },
      { threshold: 0.5 } // trigger when 50% of video is visible
    );
    videoObserver.observe(wrap);
  });

  // ===== SCROLL REVEAL =====
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            // Stagger siblings
            const delay = entry.target.dataset.delay || 0;
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el, i) => {
      // Auto-stagger sibling cards
      const siblings = el.parentElement ? el.parentElement.querySelectorAll('.reveal') : [];
      const idx = Array.from(siblings).indexOf(el);
      if (idx > 0) el.dataset.delay = idx * 100;
      observer.observe(el);
    });
  }

  // ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});
